class SubscriptionWidget extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    this.sectionId = this.getAttribute('section-id');
    this.radios = this.querySelectorAll('.purchase-radio');
    this.frequencySelects = this.querySelectorAll('.frequency-select');

    this.productForm = document.getElementById(`product-form-${this.sectionId}`);
    this.sellingPlanInput = this.productForm?.querySelector('input[name="selling_plan"]');

    if (!this.sellingPlanInput && this.productForm) {
      this.sellingPlanInput = document.createElement('input');
      this.sellingPlanInput.type = 'hidden';
      this.sellingPlanInput.name = 'selling_plan';
      this.productForm.appendChild(this.sellingPlanInput);
    }

    this.radios.forEach((radio) => {
      radio.addEventListener('change', () => this.handlePurchaseOptionChange(radio));
    });

    this.frequencySelects.forEach((select) => {
      select.addEventListener('change', () => this.handleFrequencyChange(select));
    });
  }

  handlePurchaseOptionChange(radio) {
    if (radio.value === 'onetime') {
      if (this.sellingPlanInput) {
        this.sellingPlanInput.value = '';
      }
    } else if (radio.value === 'subscription') {
      const sellingPlanId = radio.dataset.sellingPlanId;

      const frequencySelect = radio.closest('.subscription-option')?.querySelector('.frequency-select');
      const finalSellingPlanId = frequencySelect ? frequencySelect.value : sellingPlanId;

      if (this.sellingPlanInput) {
        this.sellingPlanInput.value = finalSellingPlanId;
        this.renderProductInfo();
      }
    }
  }

  handleFrequencyChange(select) {
    const sellingPlanId = select.value;

    if (this.sellingPlanInput) {
      this.sellingPlanInput.value = sellingPlanId;
      this.renderProductInfo();
    }

    const radio = select.closest('.subscription-option')?.querySelector('.purchase-radio');
    if (radio) {
      radio.dataset.sellingPlanId = sellingPlanId;
    }
  }

  renderProductInfo() {
    const sectionId = this.sectionId;
    const requestedVariantId = document.querySelector(`#product-form-${sectionId} [name="id"]`).value;
    const sellingPlan = document.querySelector(`#product-form-${sectionId} [name="selling_plan"]`).value;
    let url = `${this.dataset.url}?variant=${requestedVariantId}&section_id=${sectionId}`;

    if (sellingPlan && sellingPlan !== 'null') {
      url += `&selling_plan=${sellingPlan}`;
    }

    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html');

        const subscriptionSource = html.getElementById(`Subscription-${sectionId}`);
        const subscriptionDestination = document.getElementById(`Subscription-${sectionId}`);

        if (subscriptionSource && subscriptionDestination)
          subscriptionDestination.innerHTML = subscriptionSource.innerHTML;
      });
  }
}

customElements.define('subscription-widget', SubscriptionWidget);
